import API from 'services/API/index';

export default function getTransitionToken(isMessagePage) {
  return API.request({
    method: 'GET',
    url: isMessagePage ? `/transition/v2.0?messagePage=true` : `/transition/v2.0`,
  });
}
